import * as React from 'react';
import { DiagnosticsPanel } from 'owa-diagnostics';
var DiagnosticsPane = function (props) {
    return React.createElement(DiagnosticsPanel, { onDismiss: props.onDismiss });
};
export default DiagnosticsPane;
//# sourceMappingURL=DiagnosticsPane.js.map